var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99905 12C9.31267 12 12 9.31457 12 6.00095C12 2.68543 9.31267 0 5.99905 0C2.68543 0 0 2.68543 0 6.00095C0 9.31457 2.68543 12 5.99905 12ZM5.1571 3.34456C5.1571 2.87911 5.53442 2.50179 5.99988 2.50179C6.46533 2.50179 6.84265 2.87911 6.84265 3.34456C6.84265 3.81002 6.46533 4.18734 5.99988 4.18734C5.53442 4.18734 5.1571 3.81002 5.1571 3.34456ZM5.36259 5.07822H6.63671V9.35235H5.36259V5.07822Z",
    fill: "#9097A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipIcon);
export default __webpack_public_path__ + "static/media/tooltip-icon.7dcd64deac7f5fa1a00da7326aed3897.svg";
export { ForwardRef as ReactComponent };